<!--  付款申请行信息 -->
<template>
  <div>
    <vxe-toolbar v-if="canEdit">
      <template v-slot:buttons>
        <div v-if="!feeInfo.isRelatedInstruction">
          <vxe-button
            @click="insertFirstRow()"
            v-if="!feeInfo.isMoreDeliverer"
            type="primary"
            size="medium"
            class="vxe-btn-primary"
            ><svg-icon
              class="icon-img"
              style="font-size: 16px; padding-right: 6px"
              icon-class="icon-add"
            />新增</vxe-button
          >
          <vxe-button
            @click="handleDelete('firstClaim')"
            type="primary"
            size="medium"
            icon="el-icon-delete"
            class="vxe-btn-delete"
            >删除</vxe-button
          >
          <vxe-button
            @click="handleSettleBatch()"
            type="primary"
            size="medium"
            v-if="
              userInfo.businessGroup == '物贸'
                ? !feeInfo.isMoreDeliverer
                : !feeInfo.isPrepay && !feeInfo.isMoreDeliverer
            "
            icon="el-icon-plus"
            class="vxe-btn-primary"
            >关联应付结算单</vxe-button
          >
        </div>
        <div v-else>
          <vxe-button
            @click="handleQueryShipping()"
            type="primary"
            size="medium"
            icon="el-icon-view"
            class="vxe-btn-primary"
            >查看</vxe-button
          >
        </div>
      </template>
    </vxe-toolbar>
    <vxe-toolbar v-if="!!feeInfo.isRelatedInstruction && !canEdit">
      <template v-slot:buttons>
        <vxe-button
          @click="handleQueryShipping()"
          type="primary"
          size="medium"
          icon="el-icon-view"
          class="vxe-btn-primary"
          >查看</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      show-overflow
      resizable
      ref="firstClaim"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="payApplyDetailList"
      :columns="payApplyColumn"
      max-height="400"
      :edit-rules="payApplyRules"
      :edit-config="{ trigger: 'click', mode: 'row', activeMethod: activeRowMethod }"
      @select-change="handleSelectionChange"
      show-footer
      :footer-method="footerMethod"
    >
    </vxe-grid>
    <!-- 关联结算批次 -->
    <settlement
      ref="settlementBatch"
      @updateSettle="updateSettle"
      :defaultSettlementBusinessType="settlementBusinessType"
    ></settlement>

    <SelectTableDialog
      title="供应商发货指令列表"
      :searchColumns="[]"
      :columnList="shippingcolumnList"
      :API="SHIPPING_API"
      :extraData="extraData"
      width="1200px"
      ref="shippingInfo"
      @confirm="confirmShipping"
      :isMultiple="false"
      :page="false"
    >
    </SelectTableDialog>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import SelectTableDialog from '@/components/SelectTableDialog';
  // import API from '@/api/financeCenter/payables.js';
  import PAYMENT_API from '@/api/financeCenter/paymentApply.js';
  import Settlement from '@/components/PayableSettlement';
  import XEUtils from 'xe-utils';
  export default {
    name: 'payapplyLine',
    components: {
      Settlement,
      SelectTableDialog,
    },
    props: [
      'payApplyDetailList',
      'detail',
      'departmentList',
      'exchangeRate',
      'feeInfo',
      'invoiceCodeList',
      'paidAccountedAmount',
      'invoiceCode',
      'settleList',
      'validateForm',
      'canEdit',
      'defaultSettlementBusinessType',
    ],
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      isWuMaoAccount() {
        return ['物贸', '国贸'].includes(this.userInfo.businessGroup);
      },
      getProjectBusinessCategory() {
        if (this.settlementBusinessType == '01') {
          if (this.isWuMaoAccount) {
            return '02';
          } else {
            return '01';
          }
        } else if (this.settlementBusinessType == '02') {
          return '03';
        }
        return this.settlementBusinessType;
      },
      // 付款申请明细
      payApplyColumn() {
        return [
          {
            // checkbox
            type: 'checkbox',
            width: 50,
          },
          {
            // 序号
            type: 'seq',
            width: 80,
            title: this.$t('paymentApplyListAdd.invoiceLine.table.payableInvoiceDetailNo'),
          },
          {
            // 实际收款人
            field: 'actualPayee',
            title: this.$t('paymentApplyListAdd.invoiceLine.table.actualPayee'),
            width: 120,
            ...(!this.feeInfo.isMoreDeliverer
              ? {
                  editRender: { name: 'ElInput', props: { clearable: true } },
                  slots: {
                    default: ({ row }) => {
                      return [<span>{row.actualPayeeName}</span>];
                    },
                    edit: ({ row }) => {
                      return [
                        <search-table
                          searchType="supplier"
                          isMultiple={true}
                          currentValue={row['actualPayeeName']}
                          checkRowKeys={[row['actualPayee']]}
                          onInput={(val) => this.chooseSearchTable(val, row, 'actualPayee')}
                          extraData={{
                            companyCode: this.feeInfo?.requestCompanyCode,
                            departmentCode: this.feeInfo?.requestDepartmentCode,
                            partnerTypes: '',
                            requestStatus: 'ZT03',
                          }}
                        ></search-table>,
                      ];
                    },
                  },
                }
              : {
                  slots: {
                    default: ({ row }) => {
                      return [<span>{row.actualPayeeName}</span>];
                    },
                  },
                }),
          },
          // 开户银行
          {
            field: 'actualBankName',
            title: this.$t('paymentApplyListAdd.invoiceLine.table.actualBankName'),
            width: 180,
          },
          // 联行号
          {
            field: 'actualBankUnionNumber',
            title: this.$t('paymentApplyListAdd.invoiceLine.table.actualBankUnionNumber'),
            width: 180,
          },
          // 实际收款人账号
          {
            field: 'actualPayeeAccount',
            title: this.$t('paymentApplyListAdd.invoiceLine.table.actualPayeeAccount'),
            width: 180,
            editRender: {
              name: 'ElSelect',
              options: this.accoutList,
              props: {
                clearable: true,
                filterable: true,
              },
              events: { change: (obj) => this.rowChange(obj, 'actualPayeeAccount') },
            },
          },
          // 供应商发货指令数量
          {
            field: 'requestQuantity',
            title: '供应商发货指令数量',
            width: 180,
          },
          {
            //申请金额原币
            field: 'requestAmount',
            title: this.$t('paymentApplyListAdd.invoiceLine.table.requestAmount'),
            width: 120,
            ...{
              editRender: {
                name: 'ElInput',
                props: {
                  clearable: true,
                },
              },
              slots: {
                default: ({ row }) => {
                  return [
                    <span>
                      {this.replaceZeroStr(this.$baseRequest.formatTableColumn(row.requestAmount))}
                    </span>,
                  ];
                },
                edit: ({ row }) => {
                  return [
                    <input-number-ad
                      disabled={!!this.feeInfo?.isRelatedInstruction}
                      value={row.requestAmount}
                      min={0}
                      max={99999999999999999}
                      onInput={(val) => this.chooseSearchTable(val, row, 'requestAmount')}
                    ></input-number-ad>,
                  ];
                },
              },
            },
          },
          {
            // 费用类型
            field: 'expenseDesc',
            title: '款项内容',
            width: 150,
            editRender: {
              name: 'ElSelect',
              options: this.expenseGroupList,
              props: {
                clearable: true,
                filterable: true,
              },
            },
          },

          //                         contractCurrency: this.feeInfo?.currencycode,
          // supplierNo: this.feeInfo?.payeeNo,
          // contractCategory: 'purchase',
          // contractStatus: 'ZT03',
          // contractCompanyNo: this.feeInfo?.requestCompanyCode,
          // contractBusinessDepartment: this.feeInfo?.requestDepartmentCode,
          // contractDetailCategory: 'CG01',
          {
            // 采购合同号
            field: 'purchaseOrderNo',
            title: this.$t('paymentApplyListAdd.invoiceLine.table.purchaseOrderNo'),
            width: 120,
            ...{
              editRender: { name: 'ElInput', props: { clearable: true } },
              slots: {
                default: ({ row }) => {
                  return [<span>{row.purchaseOrderNo}</span>];
                },
                edit: ({ row }) => {
                  return [
                    <search-table
                      searchType="commonContract"
                      combineExtraData={true}
                      isMultiple={true}
                      disabled={
                        !!this.feeInfo?.isRelatedInstruction || this.settlementBusinessType == '03'
                      }
                      currentValue={row['purchaseOrderNo']}
                      checkRowKeys={[row['purchaseOrderNo']]}
                      parseExtendMap={true}
                      onInput={(val) => this.chooseSearchTable(val, row, 'purchaseOrderNo')}
                      extraData={{
                        businessCategory: '01',
                        contractCurrency: this.feeInfo.currencycode,
                        supplierNo: this.feeInfo?.payeeNo,
                        contractCategory: 'purchase',
                        contractCompanyNo: this.feeInfo?.requestCompanyCode,
                        contractDepartmentNo: this.feeInfo?.requestDepartmentCode,
                        contractDetailCategory: 'CG01',
                        kind: 'line',
                      }}
                    ></search-table>,
                  ];
                },
              },
            },
          },
          {
            // extraData={{ contractNo: row['purchaseOrderNo'] }}
            // 采购合同行项目号
            field: 'puchaseOrderDetailNo',
            title: this.$t('paymentApplyListAdd.invoiceLine.table.puchaseOrderDetailNo'),
            width: 120,
            ...{
              editRender: { name: 'ElInput', props: { clearable: true } },
              slots: {
                default: ({ row }) => {
                  return [<span>{row.puchaseOrderDetailNo}</span>];
                },
                edit: ({ row }) => {
                  return [
                    <search-table
                      searchType="commonContract"
                      combineExtraData={true}
                      isMultiple={true}
                      disabled={
                        !!this.feeInfo?.isRelatedInstruction ||
                        this.settlementBusinessType == '02' ||
                        this.settlementBusinessType == '03' ||
                        this.settlementBusinessType == '04'
                      }
                      parseExtendMap={true}
                      currentValue={row['puchaseOrderDetailNo']}
                      checkRowKeys={[row['puchaseOrderDetailNo']]}
                      onInput={(val) => this.chooseSearchTable(val, row, 'puchaseOrderDetailNo')}
                      extraData={{
                        contractNoLike: row['contractNo'],
                        contractCurrency: this.feeInfo.currencycode,
                        businessCategory: '01',
                        contractCategory: 'purchase',
                        contractCompanyNo: this.feeInfo?.requestCompanyCode,
                        contractDepartmentNo: this.feeInfo?.requestDepartmentCode,
                        contractDetailCategory: 'CG01',
                        kind: 'line',
                      }}
                    ></search-table>,
                  ];
                },
              },
            },
          },
          {
            // 商品/服务描述
            field: 'productName',
            width: 120,
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
                disabled:
                  !!this.feeInfo?.isRelatedInstruction ||
                  this.settlementBusinessType == '02' ||
                  this.settlementBusinessType == '03' ||
                  this.settlementBusinessType == '04',
              },
            },
            title: this.$t('paymentApplyListAdd.invoiceLine.table.productName'),
          },
          /* {
            // 发票编号
            field: 'invoiceCode',
            title: this.$t('paymentApplyListAdd.invoiceLine.table.invoiceCode'),
            width: 140,
            ...{
              editRender: { name: 'ElInput', props: { clearable: true } },
              slots: {
                default: ({ row }) => {
                  return [<span>{row.invoiceCode}</span>];
                },
                edit: ({ row }) => {
                  return [
                    <search-table
                      searchType="payable"
                      isMultiple={true}
                      currentValue={row['invoiceCode']}
                      checkRowKeys={[row['invoiceCode']]}
                      extraData={{
                        invoiceUnitNo: this.feeInfo.payeeNo,
                        payableInvoiceStatusList: ['submitted', 'hold'],
                      }}
                      onInput={(val) => this.chooseSearchTable(val, row, 'invoiceCode')}
                    ></search-table>,
                  ];
                },
              },
            },
          }, */
          {
            // 销售合同号
            field: 'salesOrderNo',
            title: this.$t('paymentApplyListAdd.invoiceLine.table.salesOrderNo'),
            width: 120,
            ...{
              editRender: { name: 'ElInput', props: { clearable: true } },
              slots: {
                default: ({ row }) => {
                  return [<span>{row.salesOrderNo}</span>];
                },
                edit: ({ row }) => {
                  return [
                    <search-table
                      searchType="commonContract"
                      combineExtraData={true}
                      isMultiple={true}
                      disabled={
                        !!this.feeInfo?.isRelatedInstruction ||
                        this.settlementBusinessType == '04' ||
                        this.disableSaleContractNo
                      }
                      parseExtendMap={true}
                      currentValue={row['salesOrderNo']}
                      checkRowKeys={[row['salesOrderNo']]}
                      onInput={(val) => this.chooseSearchTable(val, row, 'salesOrderNo')}
                      extraData={{
                        businessCategory: '01',
                        contractCurrency: this.feeInfo.currencycode,
                        contractCompanyNo: this.feeInfo?.requestCompanyCode,
                        contractDepartmentNo: this.feeInfo?.requestDepartmentCode,
                        customerNo: this.feeInfo.payeeNo,
                        contractCategory: 'sales',
                        contractDetailCategory: 'CG04',
                        kind: 'line',
                      }}
                    ></search-table>,
                  ];
                },
              },
            },
          },

          {
            // 销售提单号
            field: 'salesOrderDetailNo',
            title: this.$t('paymentApplyListAdd.invoiceLine.table.salesOrderDetailNo'),
            width: 120,
            ...{
              editRender: { name: 'ElInput', props: { clearable: true } },
              slots: {
                default: ({ row }) => {
                  return [<span>{row.salesOrderDetailNo}</span>];
                },
                edit: ({ row }) => {
                  return [
                    <search-table
                      searchType="salesLading"
                      isMultiple={true}
                      disabled={
                        !!this.feeInfo?.isRelatedInstruction ||
                        this.settlementBusinessType == '02' ||
                        this.settlementBusinessType == '03' ||
                        this.settlementBusinessType == '04'
                      }
                      currentValue={row['salesOrderDetailNo']}
                      checkRowKeys={[row['salesOrderDetailNo']]}
                      onInput={(val) => this.chooseSearchTable(val, row, 'salesOrderDetailNo')}
                      extraData={{
                        contractNo: row['salesOrderNo'] ? row['salesOrderNo'] : '-1',
                        ladingStatus: 'TDZT07',
                      }}
                    ></search-table>,
                  ];
                },
              },
            },
          },

          {
            // 币种
            field: 'currencyName',
            width: 120,
            title: this.$t('paymentApplyListAdd.invoiceLine.table.currencyName'),
          },
          {
            // 业务员
            field: 'businessPersonName',
            width: 120,
            title: this.$t('paymentApplyListAdd.invoiceLine.table.businessPersonName'),
          },
          {
            // 备注
            field: 'mark',
            width: 120,
            title: this.$t('paymentApplyListAdd.invoiceLine.table.mark'),
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            // 已付款金额
            field: 'paidAmount',
            width: 120,
            title: this.$t('paymentApplyListAdd.invoiceLine.table.paidAmount'),
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>
                    {this.replaceZeroStr(this.$baseRequest.formatTableColumn(row.paidAmount))}
                  </span>,
                ];
              },
            },
          },
          {
            // 未付款金额
            field: 'unpaidAmount',
            width: 120,
            title: this.$t('paymentApplyListAdd.invoiceLine.table.unpaidAmount'),
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>
                    {this.replaceZeroStr(this.$baseRequest.formatTableColumn(row.unpaidAmount))}
                  </span>,
                ];
              },
            },
          },
          {
            // 汇率
            field: 'exchangeRate',
            width: 120,
            title: this.$t('paymentApplyListAdd.invoiceLine.table.exchangeRate'),
          },
          {
            // 申请金额本位币
            field: 'requestAccountedAmount',
            width: 120,
            title: this.$t('paymentApplyListAdd.invoiceLine.table.requestAccountedAmount'),
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>
                    {this.replaceZeroStr(
                      this.$baseRequest.formatTableColumn(row.requestAccountedAmount)
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            //已付款金额本位币
            field: 'paidAccountedAmount',
            title: this.$t('paymentApplyListAdd.invoiceLine.table.paidAccountedAmount'),
            width: 120,
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>
                    {this.replaceZeroStr(
                      this.$baseRequest.formatTableColumn(row.paidAccountedAmount)
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            //未付款金额本位币
            field: 'unpaidAccountedAmount',
            title: this.$t('paymentApplyListAdd.invoiceLine.table.unpaidAccountedAmount'),
            width: 120,
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>
                    {this.replaceZeroStr(
                      this.$baseRequest.formatTableColumn(row.unpaidAccountedAmount)
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            //合同未付款
            field: 'orderUnpaidAmount',
            title: this.$t('paymentApplyListAdd.invoiceLine.table.orderUnpaidAmount'),
            width: 120,
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>
                    {this.replaceZeroStr(
                      this.$baseRequest.formatTableColumn(row.orderUnpaidAmount)
                    )}
                  </span>,
                ];
              },
            },
          },
          //projectInitiationStatusList: ['PIS04', 'PIS05', 'PIS07', 'PIS08'],
          {
            //项目
            field: 'projectInitiationNo',
            title: '项目编号',
            width: 120,
            ...{
              editRender: { name: 'ElInput', props: { clearable: true } },
              slots: {
                default: ({ row }) => {
                  return [<span>{row.projectInitiationNo}</span>];
                },
                edit: ({ row }) => {
                  return [
                    <search-table
                      disabled={
                        !!this.feeInfo?.isRelatedInstruction || this.settlementBusinessType == '03'
                      }
                      searchType="commonProject"
                      isMultiple={true}
                      combineExtraData={true}
                      currentValue={row['projectInitiationNo']}
                      checkRowKeys={[row['projectInitiationNo']]}
                      parseExtendMap={true}
                      extraData={{
                        businessCategory: '01',
                        projectCompanyNo: this.feeInfo?.requestCompanyCode,
                        projectDepartmentNo: this.feeInfo?.requestDepartmentCode,
                      }}
                      onInput={(val) => this.chooseSearchTable(val, row, 'projectInitiationNo')}
                    ></search-table>,
                  ];
                },
              },
            },
          },
          {
            // 新增字段，项目可用额度
            field: 'availableAmount',
            title: '项目可用额度',
            width: 120,
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
                disabled: true,
              },
            },
          },
          {
            // 结算单编号
            field: 'payableSettlementNo',
            title: '结算单编号',
            width: 150,
            ...(!this.feeInfo.isPrepay && !this.feeInfo.isMoreDeliverer
              ? {
                  editRender: { name: 'ElInput', props: { clearable: true } },
                  slots: {
                    default: ({ row }) => {
                      return [<span>{row.payableSettlementNo}</span>];
                    },
                    edit: ({ row }) => {
                      return [
                        <search-table
                          searchType="commonPayableSettlement"
                          combineExtraData={true}
                          isMultiple={true}
                          currentValue={row['payableSettlementNo']}
                          checkRowKeys={[row['payableSettlementNo']]}
                          onInput={(val) => this.chooseSearchTable(val, row, 'payableSettlementNo')}
                          extraData={{
                            settlementCompanyNo: this.feeInfo?.requestCompanyCode,
                            settlementDepartmentNo: this.feeInfo?.requestDepartmentCode,
                            settlementStatus: '04',
                            settlementBusinessType: this.settlementBusinessType,
                            isMoreDeliverer: 0,
                            isPreSettlement: 0,
                            isPay: '1',
                          }}
                        ></search-table>,
                      ];
                    },
                  },
                }
              : ''),
          },
          {
            //结算单未付金额
            field: 'settlementUnpaidAmount',
            title: this.$t('paymentApplyListAdd.invoiceLine.table.settlementUnpaidAmount'),
            width: 120,
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>
                    {this.replaceZeroStr(
                      this.$baseRequest.formatTableColumn(row.settlementUnpaidAmount)
                    )}
                  </span>,
                ];
              },
            },
          },
          {
            //结算单已付金额
            field: 'settlementPaidAmount',
            title: this.$t('paymentApplyListAdd.invoiceLine.table.settlementPaidAmount'),
            width: 120,
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>
                    {this.replaceZeroStr(
                      this.$baseRequest.formatTableColumn(row.settlementPaidAmount)
                    )}
                  </span>,
                ];
              },
            },
          },
          // 开户分行
          {
            field: 'actualBankBranch',
            title: this.$t('paymentApplyListAdd.invoiceLine.table.actualBankBranch'),
            width: 180,
          },
        ];
      },
      payApplyRules() {
        const prefixInput = this.$t('paymentApplyListAdd.invoiceLine.rules.input');
        const prefixSelect = this.$t('paymentApplyListAdd.invoiceLine.rules.select');
        {
          /* const { paymentType } = 'C0001'; //this.feeInfo 注意 */
        }
        // 当填写结算批次后 发货指令必填
        {
          /* const invoiceAmountValidate = (rule, value, callback, { row }) => {
          if (row['settleBatchNo']) {
            value ? callback() : callback(new Error('当结算批次不为空，发货指令必填'));
          } else {
            callback();
          }
        }; */
        }
        const validRules = {
          lineNum: [
            {
              required: true,
              message: prefixInput + this.$t('paymentApplyListAdd.invoiceLine.table.lineNum'),
            },
            { max: 5, message: '文件名长度在 1 到 5 个字符' },
          ],
          requestAmount: [
            {
              required: true,
              message: prefixInput + this.$t('paymentApplyListAdd.invoiceLine.table.requestAmount'),
            },
          ],
          expenseGroup: [
            {
              required: true,
              message: prefixInput + this.$t('paymentApplyListAdd.invoiceLine.table.expenseGroup'),
            },
          ],
          expenseDesc: [
            {
              required: true,
              message: prefixSelect + this.$t('paymentApplyListAdd.invoiceLine.table.expenseType'),
            },
          ],
          projectInitiationNo: [
            {
              required: false,
              message:
                prefixSelect + this.$t('paymentApplyListAdd.invoiceLine.table.projectInitiationNo'),
            },
          ],
          instructionNo: [
            {
              // validator: invoiceAmountValidate
            },
          ],
          purchaseOrderNo: [
            {
              required: ['PT01'].indexOf(this.feeInfo.paymentType) != -1,
              message:
                prefixSelect + this.$t('paymentApplyListAdd.invoiceLine.table.purchaseOrderNo'),
            },
          ],
          salesOrderNo: [
            {
              required: ['PT03'].indexOf(this.feeInfo.paymentType) != -1,
              message: prefixSelect + this.$t('paymentApplyListAdd.invoiceLine.table.salesOrderNo'),
            },
          ],
          actualPayeeAccount: [
            {
              required: true,
              message:
                prefixSelect + this.$t('paymentApplyListAdd.invoiceLine.table.actualPayeeAccount'),
            },
          ],
          actualPayee: [
            {
              required: true,
              message: prefixSelect + this.$t('paymentApplyListAdd.invoiceLine.table.actualPayee'),
            },
          ],
        };
        return validRules;
      },

      shippingcolumnList() {
        return [
          {
            prop: 'instructionNo',
            label: '发货指令编号',
            visible: true,
            width: 120,
          },
          {
            prop: 'purchaseContractNo',
            label: '采购合同号',
            visible: true,
            width: 120,
          },
          {
            prop: 'instructionStatus',
            label: '发货指令状态',
            visible: true,
            width: 120,
            render: (value, row) => this.renderInstructionStatus(value, row),
          },
          {
            prop: 'partnerName',
            label: '供应商名称',
            visible: true,
            width: 120,
          },
          {
            prop: 'deliverDate',
            label: '发货日期',
            visible: true,
            width: 120,
          },
          {
            prop: 'salesmanName',
            label: '业务员',
            visible: true,
            width: 120,
          },
          {
            prop: 'businessInboundBatchNo',
            label: '入库批次号',
            visible: true,
            width: 120,
          },
          {
            prop: 'baseName',
            label: '基地简称',
            visible: true,
            width: 120,
          },
          {
            prop: 'carNo',
            label: '车牌号',
            visible: true,
            width: 120,
          },
          {
            prop: 'netWeight',
            label: '净重（吨）',
            visible: true,
            width: 120,
          },
          {
            prop: 'deduct',
            label: '扣杂（吨）',
            visible: true,
            width: 120,
          },
          {
            prop: 'instructionNumber',
            label: '供应商发货指令数量',
            visible: true,
            width: 120,
          },
          {
            prop: 'businessVariablePrice',
            label: '业务结算单价',
            visible: true,
            width: 120,
          },
          {
            prop: 'businessVariablePriceWithTax',
            label: '业务结算金额',
            visible: true,
            width: 120,
          },
          {
            prop: 'taxRate',
            label: '税率',
            visible: true,
            width: 120,
          },
          {
            prop: 'applyMoney',
            label: '本次付款金额',
            visible: true,
            width: 120,
          },
        ];
      },
    },

    mounted() {
      // 初始化表格是否编辑
      this.editConfig = this.canEdit ? { trigger: 'click', mode: 'row' } : {};
      if (!this.detail) {
        // this.table=[]
      }
      this.getDictList();
    },
    watch: {
      // 判断表格编辑功能是否禁用
      canEdit: function (newQuestion) {
        this.editConfig = newQuestion ? { trigger: 'click', mode: 'row' } : {};
      },
      baseDataRules: function () {
        this.$nextTick(() => {
          this.$refs.baseData.clearValidate();
        });
      },
      departmentList: function () {
        // this.columnList= Object.assign({},this.columnList)
      },
      defaultSettlementBusinessType: {
        handler(newVal) {
          //01 贸易 02 多式联运 03 园区物业 04 三方租赁
          if (newVal && newVal.length) {
            if (newVal != this.settlementBusinessType) {
              let fulldata = this.$refs.firstClaim.getTableData().fullData;
              fulldata = fulldata.map((item) => {
                item.expenseDesc = null;
                item.projectInitiationNo = null;
                item.salesOrderNo = null;
                item.purchaseOrderNo = null;
                item.payableSettlementNo = null;
                item.salesOrderDetailNo = null;
                item.productName = null;
                item.puchaseOrderDetailNo = null;
                return item;
              });
              this.$refs.firstClaim.updateData(fulldata);
              switch (newVal) {
                case '01':
                  this.curExpenseType = 'expense_item';
                  break;
                case '02':
                  this.curExpenseType = 'intermodality_expense_item';
                  break;
                case '03':
                  this.curExpenseType = 'park_expense_item';
                  break;
                case '04':
                  this.curExpenseType = 'supervise_expense_item';
                  break;
                case '05':
                  this.curExpenseType = 'expense_item';
                  break;
                default:
                  break;
              }
              this.getDictList();
            }
            this.settlementBusinessType = newVal;
            console.log('settlement Changed', newVal);
          }
        },
      },
      feeInfo: {
        handler(newV, oldV) {
          if (newV.currencyCode != oldV.currencyCode) {
            let fulldata = this.$refs.firstClaim.getTableData().fullData;
            fulldata = fulldata.map((item) => {
              item.currencyCode = newV.currencyCode;
              item.currencyName = newV.currencyName;
              return item;
            });
            this.$refs.firstClaim.updateData(fulldata);
          }
        },
        deep: true,
      },
      // 判断表格编辑功能是否禁用
      exchangeRate: function (newV) {
        let fulldata = this.$refs.firstClaim.getTableData().fullData;
        fulldata = fulldata.map((row) => {
          row['exchangeRate'] = newV;
          //申请金额本位币=申请金额原币*汇率
          row['requestAccountedAmount'] = this.$cal.calCommon(
            row['requestAmount'],
            row['exchangeRate'],
            '*',
            'amount'
          );
          //已付款金额本位币=已付款金额金额原币*汇率
          row['paidAccountedAmount'] = this.$cal.calCommon(
            row['paidAmount'],
            row['exchangeRate'],
            '*',
            'amount'
          );
          // 未付款金额本位币=申请金额本位币-已付款金额本位币
          row['unpaidAccountedAmount'] = this.$cal.calCommon(
            row['requestAccountedAmount'],
            row['paidAccountedAmount'],
            '-',
            'amount'
          );
          this.acount('paidAccountedAmount', 'paidAccountedAmount', row);
          this.acount('unpaidAccountedAmount', 'unpaidAccountedAmount', row);
          this.acount('requestAccountedAmount', 'requestAccountedAmount', row);
          return row;
        });
        this.$refs.firstClaim.updateData(fulldata);
      },
    },
    data() {
      return {
        load: false,
        expenseGroupList: [], // 费用大类
        taxRateList: [], //税率
        delList: [], // 行删除列表
        accoutList: [], // 收款人账号列表
        contractUnPaidAmount: null, // 合同未付款金额
        settlementBusinessType: '',
        SHIPPING_API: PAYMENT_API.GET_INSTRUCTION_DETAIL,
        extraData: {},
        multipleSelection: [],
        //初始款项内容为01物贸
        curExpenseType: 'expense_item',
        disableSaleContractNo: false,
      };
    },
    methods: {
      // 底部合计值
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            if (column?.property === 'requestQuantity') {
              return XEUtils.toFixedNumber(XEUtils.calSum(data, column.property), 4);
            }
            if (column?.property === 'requestAmount') {
              return XEUtils.toFixedNumber(XEUtils.calSum(data, column.property), 2);
            }
            return null;
          }),
        ];
      },
      //checkbox选中触发事件
      handleSelectionChange(val) {
        this.multipleSelection = val.selection;
      },
      renderInstructionStatus(value) {
        let arr = {
          0: this.$t('supplierDeliveryOrder.search.instructionStatusOptionOne'),
          1: this.$t('supplierDeliveryOrder.search.instructionStatusOptionThree'),
          3: '已撤销',
        };
        return arr[value];
      },
      confirmShipping() {},
      // 查看发货指令
      handleQueryShipping() {
        if (this.multipleSelection.length != 1) {
          this.$message.error('请选择一条数据！');
          return;
        }
        let obj = this.multipleSelection[0];
        this.extraData = {
          payBatchNo: obj.instructionPaymentConfirmId,
          contractNo: obj.purchaseOrderNo,
        };
        this.$refs.shippingInfo.$refs.footer.style.display = 'none';
        this.$refs.shippingInfo.handleOpen();
      },
      async handleSettleBatch() {
        let flag = await this.validateForm(); //校验表单
        // 关联结算单
        if (this.feeInfo.settlementBusinessType) {
          this.settlementBusinessType = this.feeInfo.settlementBusinessType;
        }
        if (flag) this.$refs.settlementBatch.open(this.feeInfo);
      },

      async updateSettle(v, row = {}, assignAmount = true) {
        let obj = v[0];

        if (obj.supplyDetailsAttachments && obj.supplyDetailsAttachments?.length != 0) {
          this.$emit('attachmentUpdate', obj.supplyDetailsAttachments);
        }
        // 限制不能重复插入相同的数据
        const fullTableData = this.$refs.firstClaim.getTableData().fullData;
        if (fullTableData.find((item) => item.payableSettlementNo == obj.payableSettlementNo)) {
          this.$message.error('相同数据不能重复添加');
          return;
        }
        console.log(obj, row, '新增数据');
        if (obj.payableSettlementNo) {
          await this.getOrderDetailByContractNo(obj.contractNo);
        }
        //结算单未付金额仍然取原来的未付款金额，
        const settlmentUnpaidAmounttemp = obj.unpaidAmount;
        if (obj.id) {
          let result = await this.$axios.post(`${PAYMENT_API.QUERY_DEFALUT_VALUE}/${obj.id}`);
          console.log('获取数值', result);
          obj.unpaidAmount = (result?.data - 0).toFixed(2);
        }

        row = {
          ...row,
          id: null,
          actualPayee: obj.actualPayee,
          actualPayeeName: obj.actualPayeeName,
          actualPayeeAccount: obj.actualPayeeAccount,
          actualBankName: obj.actualBankName,
          actualBankBranch: obj.actualBankBranch,
          actualBankNo: obj.actualBankNo,
          actualBankUnionNumber: obj.actualBankUnionNumber,
          purchaseOrderNo: obj.contractNo,
          currencycode: this.feeInfo.currencycode || this.feeInfo.companyCurrencyCode,
          currencyName: this.feeInfo.currencyName || this.feeInfo.companyCurrencyName,
          businessPersonName: obj.salesmanName,
          businessPersonNo: obj.salesmanNo,
          payableSettlementNo: obj.payableSettlementNo,
          projectInitiationNo: obj.projectInitiationNo,
          projectName: obj.projectName,
        };

        if (assignAmount) {
          row = {
            ...row,
            requestAmount: obj.unpaidAmount,
            exchangeRate: this.exchangeRate,
            settlementUnpaidAmount: settlmentUnpaidAmounttemp || 0,
            settlementPaidAmount: obj.paidAmount || 0,
            paidAmount: 0,
            unpaidAmount: this.$cal.calCommon(obj.unpaidAmount, 0, '-', 'amount'), //未付款金额
            requestAccountedAmount: this.$cal.calCommon(
              obj.unpaidAmount,
              this.exchangeRate,
              '*',
              'amount'
            ), //申请金额本位币
            paidAccountedAmount: 0, //已付款金额本位币
            unpaidAccountedAmount: this.$cal.calCommon(
              this.$cal.calCommon(obj.unpaidAmount, this.exchangeRate, '*', 'amount'),
              this.$cal.calCommon(0, this.exchangeRate, '*', 'amount'),
              '-',
              'amount'
            ), //未付款金额本位币
            orderUnpaidAmount: obj.payableSettlementNo ? this.contractUnPaidAmount : null,
          };
        }

        if (row.projectInitiationNo) {
          await this.assignAvailableAmount(row, row.projectInitiationNo);
        }

        if (this.settlementBusinessType == '03') {
          row.purchaseOrderNo = null;
          row.salesOrderNo = obj.contractNo;
          this.disableSaleContractNo = true;
        } else {
          this.disableSaleContractNo = false;
        }

        if (row?._XID) {
          let fulldata = this.$refs.firstClaim.getTableData().fullData;
          let index = fulldata.findIndex((item) => item._XID == row._XID);
          fulldata[index] = row;
          this.$refs['firstClaim'].loadData(fulldata);
          this.updateBillInfo();
        } else {
          this.$refs['firstClaim'].insertAt(row, null).then(({ row }) => {
            if (assignAmount) {
              // 未付款金额本位币=申请金额本位币-已付款金额本位币
              row['unpaidAccountedAmount'] = this.$cal.calCommon(
                row['requestAccountedAmount'],
                row['paidAccountedAmount'],
                '-',
                'amount'
              );
              this.updateBillInfo();
            }
          });
        }

        console.log('row---', row);
        /* let rows = this.$refs.firstClaim.getCheckboxRecords();
        rows.forEach((row) => {
          row['settleBatchNo'] = v[0].settleNo;
          row['supplyChainNo'] = v[0].supplierNo;
          row['supplyChainName'] = v[0].supplierName;
          row['contractNo'] = v[0].orderNo;
          row['contractList'] = v[0].contractNoList;
        });
        this.$axios.post(PAYMENT_API.UPDATE_SETTLE, rows).then((res) => {
          if (res.data.code == 0) {
            this.$refs.settlementBatch.close();
            this.$emit('getDetail', this.feeInfo.id);
          } else {
            return this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        }); */
      },
      editActivedEvent() {},
      activeRowMethod({ row }) {
        //在编辑款项内容和备注时不修改其他信息
        this.getBankInfo(row.actualPayee, row);
        //禁用编辑
        return this.canEdit;
      },
      editClosedEvent() {},
      getSelectLabel(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      // 初始化数据
      initData(table = []) {
        table.forEach((i) => {
          if (i.taxRateDict) {
            i.taxRate = i.taxRateDict;
            i.currencyName = i.taxRateDict;
          }
        });
        return table;
      },
      async assignAvailableAmount(row, projectInitiationNo) {
        if (projectInitiationNo) {
          let res = await this.$axios.post('/sales/creditLimitSummary/listProject', {
            quotaType: 'projectQuota',
            projectCodeList: [projectInitiationNo],
          });
          if (res.data.code == 0 && res.data.data?.length != 0) {
            let obj = res.data.data[0];
            if (obj) {
              row['availableAmount'] = obj['availableAmount'];
            }
          } else {
            {
              /* this.$message({ showClose: true, message: res.data.msg, type: 'error' }); */
            }
          }
        }
      },
      // 弹出框选择事件
      chooseSearchTable(v, row, prop) {
        if (v == null) {
          row[prop] = v;
        } else if (prop === 'purchaseOrderNo') {
          //校验数据是否重复
          let fulldata = this.$refs.firstClaim.getTableData().fullData;
          if (fulldata.find((item) => item.purchaseOrderNo == v[0]['contractNo'])) {
            this.$message.error('相同数据不能重复添加');
            row['purchaseOrderNo'] = null;
            return;
          }

          //采购合同号
          row['purchaseOrderNo'] = v[0]['contractNo'];
          row['puchaseOrderDetailNo'] = v[0]['contractDetailNo'];
          row['orderUnpaidAmount'] = v[0]['unpaidAmount'];
          if (v[0] && v[0]['projectInitiationNo']) {
            row['projectInitiationNo'] = v[0]['projectInitiationNo'];
            row['projectName'] = v[0]['projectName'];
          }
          if (v[0] && v[0]['projectCode']) {
            row['projectInitiationNo'] = v[0]['projectCode'];
            row['projectName'] = v[0]['projectName'];
          }
          this.assignAvailableAmount(row, row['projectInitiationNo']);

          /* row['productName'] = v[0]['productDesc']; */
          /* row['productNo'] = v[0]['productNo']; */
          if (!row['businessPersonName']) row['businessPersonName'] = v[0]['contractSalesmanName'];
          row['salesOrderNo'] = null;
        } else if (prop === 'puchaseOrderDetailNo') {
          //采购合同行
          row['puchaseOrderDetailNo'] = v[0]['contractDetailNo'];
          if (!row['businessPersonName']) row['businessPersonName'] = v[0]['contractSalesmanName'];
        } else if (prop === 'invoiceCode') {
          //发票
          row['invoiceCode'] = v[0]['invoiceCode'];
          row['invoiceId'] = v[0]['id'];
        } else if (prop === 'salesOrderDetailNo') {
          //销售合同行
          row['salesOrderDetailNo'] = v[0]['ladingNo'];
        } else if (prop === 'salesOrderNo') {
          //销售合同号
          row['salesOrderNo'] = v[0]['contractNo'];
          row['orderUnpaidAmount'] = v[0]['unpaidAmount'];
          if (!row['businessPersonName']) row['businessPersonName'] = v[0]['contractSalesmanName'];
          row['puchaseOrderDetailNo'] = null;
          {
            /* row['productName'] = null; */
          }
          {
            /* row['productNo'] = null; */
          }
          row['purchaseOrderNo'] = null;
        } else if (prop == 'instructionNo') {
          row['instructionNo'] = v[0].instructionNo;
          row['instructionDetailId'] = v[0].instructionDetailId;
          row['instructionDetailNo'] = v[0].instructionDetailNo;
        } else if (prop == 'contractNo') {
          //业务订单号
          row['contractNo'] = v[0].orderNo;
        } else if (prop == 'supplychain') {
          row['supplyChainNo'] = v[0].supplierCode;
          row['supplyChainName'] = v[0].supplierName;
        } else if (prop == 'requestAmount') {
          row[prop] = v;
          this.handleRequestAmount(prop, row);
        } else if (prop == 'expenseType') {
          console.log(row, v, row[prop]);
        } else if (prop == 'projectInitiationNo') {
          {
            /* row['projectInitiationName'] = v[0].projectName; */
          }
          //row['projectInitiationNo'] = v[0].projectInitiationNo;
          row['projectInitiationNo'] = v[0].projectNo;
          row['projectName'] = v[0].projectName;
          {
            /* console.log(row.projectInitiationName) */
          }
        } else if (prop == 'actualPayee') {
          row['actualPayee'] = v[0].partnerCode;
          row['actualPayeeName'] = v[0].partnerZhName;
          // 获取合作伙伴下的银行账号
          this.getBankInfo(row.actualPayee, row);
        } else if (prop == 'payableSettlementNo') {
          //传true就给金额赋值
          this.updateSettle(v, row, v[0].paymentStatus != '01');
        } else {
          row[prop] = v;
        }
        this.updateData();
      },
      // 获取合作伙伴下的银行账号
      async getBankInfo(partnerCode) {
        let res = await this.$axios.get(PAYMENT_API.GET_PARTER_BANK, {
          partnerCode,
          companyCode: this.feeInfo?.requestCompanyCode,
        });
        if (res) {
          if (res.data.code == 0) {
            this.accoutList = res.data.data.map((item) => {
              return {
                ...item,
                value: item.bankAccount,
                label: item.bankAccount,
              };
            });
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        }
      },
      // 给行设置默认值
      setBankData(row) {
        //默认显示与表单保持一致
        if (this.feeInfo?.bankAccount) {
          row['actualPayeeAccount'] = this.feeInfo.bankAccount;
          row['actualBankName'] = this.feeInfo.bankName;
          row['actualBankNo'] = this.feeInfo.bankNo;
          row['actualBankUnionNumber'] = this.feeInfo.bankUnionNumber;
          row['actualBankBranch'] = this.feeInfo.bankBranch;
        } else {
          row['actualPayeeAccount'] = this.accoutList[0]?.value;
          row['actualBankName'] = this.accoutList[0]?.bankName;
          row['actualBankNo'] = this.accoutList[0]?.bankCode;
          row['actualBankUnionNumber'] = this.accoutList[0]?.associatedLineNumber;
          row['actualBankBranch'] = this.accoutList[0]?.accountBankBranch;
        }
      },
      // 变更实际收款人账号
      rowChange(obj, key) {
        let row = obj.row;
        if (key == 'actualPayeeAccount') {
          let accoutObj = this.accoutList.find((item) => item.value == row.actualPayeeAccount);
          row['actualPayeeAccount'] = accoutObj?.value;
          row['actualBankName'] = accoutObj?.bankName;
          row['actualBankNo'] = accoutObj?.bankCode;
          row['actualBankUnionNumber'] = accoutObj?.associatedLineNumber;
          row['actualBankBranch'] = accoutObj?.accountBankBranch;
        }
      },
      updateData() {
        let xTable = this.$refs.firstClaim;
        xTable.updateData();
      },
      // 获取合作伙伴下的银行账号
      getAccoutByPartner() {},
      // 复制行
      async handleCopy() {
        let flag = await this.validateForm(); //校验表单
        if (!flag) return;
        let selectedList = this.$refs.firstClaim.getSelectRecords();
        selectedList.map((item) => {
          this.$nextTick(() => {
            this.$refs['firstClaim'].validate().then(() => {
              this.$refs['firstClaim'].insertAt(item, null).then(({ row }) => {
                row.id = null;
                row.paidAmount = 0; //已付款金额
                row.unpaidAmount = row.requestAmount; //未付款金额
                row.paidAccountedAmount = 0;
                // 未付款金额本位币=申请金额本位币-已付款金额本位币
                row['unpaidAccountedAmount'] = this.$cal.calCommon(
                  row['requestAccountedAmount'],
                  row['paidAccountedAmount'],
                  '-',
                  'amount'
                );

                this.updateBillInfo();
              });
            });
          });
        });
      },
      // 付款新增一行
      async insertFirstRow(row) {
        let flag = await this.validateForm(); //校验表单
        let record = {};
        this.$nextTick(() => {
          if (flag) {
            this.$refs['firstClaim'].validate().then(() => {
              this.$refs['firstClaim'].insertAt(record, row).then(({ row }) => {
                row.actualPayee = this.feeInfo.payeeNo;
                row.actualPayeeName = this.feeInfo.payeeName;
                row.actualPayeeAccount = this.feeInfo.bankAccount;
                row.actualBankName = this.feeInfo.bankName;
                row.actualBankBranch = this.feeInfo.bankBranch;
                row.actualBankNo = this.feeInfo.bankNo;
                row.actualBankUnionNumber = this.feeInfo.bankUnionNumber;
                row.exchangeRate = this.exchangeRate;
                row.paidAmount = this.paidAmount || 0; //已付款金额
                row.invoiceCode = this.invoiceCode; //发票编号
                row.currencycode = this.feeInfo.currencycode;
                row.currencyName = this.feeInfo.currencyName;
                row.unpaidAmount = this.$cal.calCommon(
                  row.requestAmount,
                  row.paidAmount,
                  '-',
                  'amount'
                ); //未付款金额
                this.$refs['firstClaim'].setActiveRow(row);
              });
            });
          }
        });
      },
      // 表格删除
      handleDelete(tableName) {
        const selectedList = this.$refs[tableName].getSelectRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('receivablesManage.message.deleteSuccess'),
            });
            this.$refs[tableName].removeSelecteds();
            this.updateBillInfo();
            this.disableSaleContractNo = false;
            this.$emit('updateBillInfo', null);
          })
          .catch(() => {
            /* this.$message({
          showClose: true,
          type: "info",
          message: this.$t('receivablesManage.message.cancelled')
        }); */
          });
      },
      // 选择框选择事件
      chooseTable(val, row) {
        row['supply'] = this.settleList.find((i) => i.id == val).supplierName;
      },
      // 计算
      acount(filed, name) {
        const rows = this.$refs.firstClaim.getTableData().fullData;
        const result = rows
          .map((i) => i[filed])
          .reduce((acc, cur) => {
            return this.$cal.calCommon(acc, cur, '+');
          }, 0);
        const obj = {};
        obj[name] = result;
        this.$emit('updateBillInfo', obj);
      },
      // 更新发票头
      updateBillInfo() {
        const rows = this.$refs.firstClaim.getTableData().fullData;
        const obj = {};
        const arr = [
          { org: 'requestAmount' },
          { org: 'requestAccountedAmount' },
          { org: 'paidAmount' },
          { org: 'paidAccountedAmount' },
          { org: 'unpaidAmount' },
          { org: 'unpaidAccountedAmount' },
        ];
        arr.forEach((j) => {
          obj[j.org] = rows
            .map((i) => i[j.org])
            .reduce((acc, cur) => {
              return this.$cal.calCommon(acc, cur, '+');
            }, 0);
        });
        this.$emit('updateBillInfo', obj);
      },
      // 获取字典表
      getDictList() {
        this.expenseGroupList = this.$baseRequest.getDictListByType(this.curExpenseType);
      },
      //根据合同号获取合同未付款金额
      async getOrderDetailByContractNo(contractNo) {
        await this.$axios
          .post(PAYMENT_API.LIST_ORDER_DETAIL_BY_PAGE, { contractNo })
          .then((res) => {
            if (res.data.code === 0) {
              this.contractUnPaidAmount = res.data.data[0]?.unpaidAmount;
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          });
        ``;
      },
      // //获取行项目号
      getListOrderDetailByPage(contractNo) {
        this.$axios.post(PAYMENT_API.LIST_ORDER_DETAIL_BY_PAGE, { contractNo }).then((res) => {
          if (res.data.code === 0) {
            this.orderDetailList = res.data.data;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      // 申请金额原币
      handleRequestAmount(prop, row) {
        // 未付款金额=申请金额-已付款金额
        row['unpaidAmount'] = this.$cal.calCommon(
          row['requestAmount'],
          row['paidAmount'],
          '-',
          'amount'
        );
        //申请金额本位币=申请金额原币*汇率
        row['requestAccountedAmount'] = this.$cal.calCommon(
          row['requestAmount'],
          row['exchangeRate'],
          '*',
          'amount'
        );
        //已付款金额本位币=已付款金额金额原币*汇率
        row['paidAccountedAmount'] = this.$cal.calCommon(
          row['paidAmount'],
          row['exchangeRate'],
          '*',
          'amount'
        );
        // 未付款金额本位币=申请金额本位币-已付款金额本位币
        row['unpaidAccountedAmount'] = this.$cal.calCommon(
          row['requestAccountedAmount'],
          row['paidAccountedAmount'],
          '-',
          'amount'
        );
        this.acount('paidAmount', 'paidAmount', row);
        this.acount('unpaidAmount', 'unpaidAmount', row);
        this.acount('paidAccountedAmount', 'paidAccountedAmount', row);
        this.acount('unpaidAccountedAmount', 'unpaidAccountedAmount', row);
        this.acount('requestAmount', 'requestAmount', row);
        this.acount('requestAccountedAmount', 'requestAccountedAmount', row);
      },
      // 返回数据
      exportChildData() {
        const tableData = this.$refs.firstClaim.getTableData().fullData;
        console.log(tableData);
        // 点击提交，走校验
        if (tableData.length == 0) {
          return [];
        } else {
          return new Promise((resolve) => {
            this.$refs.firstClaim
              .validate()
              .then(() => {
                resolve(tableData);
              })
              .catch(() => {
                this.$message.error('请检查行信息');
              });
          });
        }
      },
    },
  };
</script>
